import styled from "styled-components";
import { rem } from "convert-to-ems";

export const Box = styled.div`
  position: relative;
  width: ${props => rem(props.boxWidth)};
  height: ${rem(40.4)};
  margin-top: ${props => rem(props.marginTop)};
  margin-bottom: ${props => rem(props.marginBottom)};
  margin-left: ${props => rem(props.marginLeft)};
  margin-right: ${props => rem(props.marginRight)};
`;

export const InputElement = styled.input`
  position: relative;
  ${props =>
    props.width && typeof props.width === "number"
      ? `width: ${rem(props.width)}`
      : `width: ${props.width}`};
  padding: ${rem(10)};
  outline: 0;
  border: ${rem(1)} solid #d4d7de;
  border-style: solid;
  border-radius: ${rem(4)};
  border-right: ${props => (props.srcBtn ? "none" : "1px solid #d4d7de")};
  border-top-right-radius: ${props => (props.srcBtn ? "0" : "4px")};
  border-bottom-right-radius: ${props => (props.srcBtn ? "0" : "4px")};
  box-sizing: content-box;
  z-index: 2;
  background-image: url(${props => props.src});
  background-repeat: no-repeat;
  background-position: right;
  background-origin: content-box;

  &:focus + label,
  &:valid + label {
    font-size: ${rem(12)};
    top: ${rem(-6)};
    z-index: 2;
    transition: 0.2s;
  }

  &:focus::-webkit-input-placeholder {
    color: transparent;
  }

  @media (${props => props.theme.breakpoints.mobile}) {
    ${props =>
      props.widthMobile && typeof props.widthMobile === "number"
        ? `width: ${rem(props.widthMobile)}`
        : `width: ${props.widthMobile}`};
  }
`;

export const LabelElement = styled.label`
  font-family: ${props => props.theme.baseFontFamily};
  letter-spacing: 0;
  position: absolute;
  line-height: ${rem(12)};
  color: #d4d7de;
  background-color: ${props => props.theme.baseColor};
  top: ${rem(14)};
  left: ${rem(10)};
  transition: 0.5s;
`;

export const Tooltip = styled.div`
  display: inline-block;

  &.showTooltip span {
    visibility: visible;
    opacity: 1;
  }
`;

export const TooltipIcon = styled.img`
  display: inline-block;
  position: absolute;
  right: ${rem(135)};
  top: ${rem(12)};
  z-index: 2;
`;

export const TooltipText = styled.span`
  visibility: hidden;
  width: ${rem(150)};
  font-size: ${rem(12)};
  background-color: #f0ad4e;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 3;
  bottom: 5%;
  left: 13%;
  margin-left: -50px;
  opacity: 0;
  transition: opacity 0.3s;
`;

export const ButtonElement = styled.button`
  position: absolute;
  width: ${props => rem(props.buttonWidth)};
  height: ${rem(40.4)};
  padding-right: ${rem(10)};
  border: ${rem(1)} solid #d4d7de;
  border-style: solid;
  border-radius: ${rem(4)};
  border-left: none;
  border-top-left-radius: ${props => (props.srcBtn ? "0" : "4px")};
  border-bottom-left-radius: ${props => (props.srcBtn ? "0" : "4px")};
  background-color: ${props => props.theme.baseColor};
`;
